// lib/phoneUpload.js — v201 (2026-06)
//
// Single source of truth (SSOT) for the FRONTEND side of "upload a real
// Excel/CSV file of phone numbers instead of a free-text box". Mirrors the
// campaignAudienceGate.js pattern: ONE module, imported everywhere a phone
// list is accepted. No surface pastes/normalizes numbers on its own.
//
// All normalization happens on the BACKEND via core.customer_identity
// .normalize_phone (the only allowed normalizer). This module just calls it.
import { api } from "./api";

export const PHONE_UPLOAD_ACCEPT = ".xlsx,.csv";

// Upload a real file. Returns the backend report:
//   { total, valid_count, duplicates_removed, rejected_count,
//     phones:[canonical], valid:[{raw,normalized}], rejected:[{raw,reason}] }
export async function parsePhoneUpload(file) {
  const fd = new FormData();
  fd.append("file", file);
  const r = await api.post("/audience/parse-upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data;
}

// Normalize a single manually-typed number (for single-recipient surfaces).
//   Returns { raw, normalized, valid, reason }
export async function resolveSinglePhone(phone) {
  const r = await api.post("/audience/normalize-one", { phone });
  return r.data;
}
